import { ComponentType } from 'react';
import { Endpoint } from '../types';
import { FamilySavingsInsurancePage } from '../endpoints/family-savings-insurance';
import { InsuredUniversityPage } from '../endpoints/insured-university';

export interface EndpointPageProps {
  endpoint: Endpoint;
}

export const PAGE_REGISTRY: Record<string, ComponentType<EndpointPageProps>> = {
  'family-savings-insurance': FamilySavingsInsurancePage,
  'insured-university': InsuredUniversityPage,
};
